module.exports = __webpack_public_path__ + "static/img/start-bg.dd188440.png";